export const CURATED = "curated";
export const SHARED_WITH = "shared_with";
export const SHARED_BY = "shared_by";
export const ALERTED = "alerted";
export const BOOKMARKED = "bookmarked";
export const REAL = "real";
export const OWNED = "owned";
